import { render } from "./HomeReviews.vue?vue&type=template&id=e3779298&lang=pug"
import script from "./HomeReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeReviews.vue?vue&type=script&setup=true&lang=js"

import "./HomeReviews.vue?vue&type=style&index=0&id=e3779298&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QRating from 'quasar/src/components/rating/QRating.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QRating});
